import React from "react";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ClearIcon from "@mui/icons-material/Clear";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useDispatch, useSelector } from "react-redux";
import { DataSourceSelection } from "./dataSourceSelection";

import {
  setCompareOption,
  setDateFilter,
  setDateGrouping,
  swapFilter,
} from "@/features/dataTableSlice";
import moment from "moment";
export function DateRangeSelection(props) {
  const dispatch = useDispatch();

  const [dateFilterMode, setDateFilterMode] = React.useState(1);
  const [openDateFilter, setOpenDateFilter] = React.useState(false);
  const filterAnchorRef = React.useRef(null);
  const dataPickerStartRef1 = React.useRef(null);
  const dataPickerStartRef2 = React.useRef(null);
  const dataPickerEndRef1 = React.useRef(null);
  const dataPickerEndRef2 = React.useRef(null);
  const dateFilter = useSelector((state) => state.dataTable.dateFilter);
  const selectedSource = useSelector((state) => state.dataTable.selectedSource);
  const compareOption = useSelector((state) => state.dataTable.compareOption);

  const handleSwapFilter = () => {
    dispatch(swapFilter());
  };

  const handleReset = () => {
    dispatch(
      setDateFilter({
        field: "startDate2",
        value: null,
      })
    );
    dispatch(
      setDateFilter({
        field: "endDate2",
        value: null,
      })
    );
    dispatch(setCompareOption({ value: null }));

    dispatch(setDateGrouping({ value: "day" }));
  };
  const handleMom = (field = null, value = null) => {
    const startDate1 = field === "startDate" ? value : dateFilter.startDate1;
    const endDate1 = field === "endDate" ? value : dateFilter.endDate1;
    if (
      moment(startDate1).startOf("month").isSame(moment(startDate1), "day") &&
      moment(endDate1).endOf("month").isSame(moment(endDate1), "day")
    ) {
      dispatch(
        setDateFilter({
          field: "startDate2",
          value: moment(startDate1).subtract(1, "month").startOf("month"),
        })
      );
      dispatch(
        setDateFilter({
          field: "endDate2",
          value: moment(endDate1).subtract(1, "month").endOf("month"),
        })
      );
    } else {
      dispatch(
        setDateFilter({
          field: "startDate2",
          value: moment(startDate1).subtract(1, "month"),
        })
      );
      dispatch(
        setDateFilter({
          field: "endDate2",
          value: moment(endDate1).subtract(1, "month"),
        })
      );
    }
  };
  const handleCloseDateFilter = (event) => {
    if (
      filterAnchorRef.current &&
      filterAnchorRef.current.contains(event.target)
    ) {
      return;
    }
    setOpenDateFilter(false);
  };
  let dataRangeStr1 = "選擇日期";
  if (
    moment(dateFilter.startDate1).isValid() &&
    moment(dateFilter.endDate1).isValid()
  ) {
    dataRangeStr1 = `${moment(dateFilter.startDate1).format(
      "YYYY-MM-DD"
    )} - ${moment(dateFilter.endDate1).format("YYYY-MM-DD")}`;
  } else {
    dataRangeStr1 = "選擇日期";
  }
  let dataRangeStr2 = "選擇比較日期";
  if (
    moment(dateFilter.startDate2).isValid() &&
    moment(dateFilter.endDate2).isValid()
  ) {
    dataRangeStr2 = `${moment(dateFilter.startDate2).format(
      "YYYY-MM-DD"
    )} - ${moment(dateFilter.endDate2).format("YYYY-MM-DD")}`;
  } else {
    dataRangeStr2 = "選擇比較日期";
  }
  return (
    <FormControl sx={{ m: 2 }}>
      <ButtonGroup
        variant="contained"
        aria-label="Basic button group"
        ref={filterAnchorRef}
      >
        <Button
          onClick={() => {
            setDateFilterMode(1);
            setOpenDateFilter(true);
            //dataPickerStartRef1.current?.parentElement.click();
          }}
        >
          {dataRangeStr1}
        </Button>
        <Button
          disabled={
            (!dateFilter.startDate2 && !dateFilter.endDate2) ||
            compareOption !== "custom"
          }
          onClick={handleSwapFilter}
        >
          <SwapHorizIcon fontSize="small"></SwapHorizIcon>
        </Button>
        <Button
          onClick={() => {
            setDateFilterMode(2);
            setOpenDateFilter(true);
            //dataPickerStartRef2.current?.parentElement.click();
          }}
        >
          {dataRangeStr2}
        </Button>
        <Button
          size="small"
          // aria-controls={open ? 'split-button-menu' : undefined}
          // aria-expanded={open ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleReset}
        >
          <ClearIcon fontSize="small" />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
          width: 250,
          mt: "10px!important",
        }}
        open={openDateFilter}
        anchorEl={filterAnchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleCloseDateFilter}>
                <div>
                  {dateFilterMode === 1 && (
                    <div>
                      <DatePicker
                        views={["year", "month", "day"]}
                        disableFuture
                        components={{
                          OpenPickerIcon: () => (
                            <CalendarMonthIcon ref={dataPickerStartRef1} />
                          ),
                        }}
                        label="Start Date"
                        onClose={() => {
                          dataPickerEndRef1.current.parentElement.click();
                        }}
                        value={dateFilter.startDate1}
                        onChange={(newValue) => {
                          dispatch(
                            setDateFilter({
                              field: "startDate1",
                              value: moment(newValue).format("YYYY-MM-DD"),
                            })
                          );

                          if (dateFilter.endDate1 === null) {
                            if (
                              moment(newValue).endOf("month").isAfter(moment())
                            ) {
                              dispatch(
                                setDateFilter({
                                  field: "endDate1",
                                  value: moment().format("YYYY-MM-DD"),
                                })
                              );
                            } else {
                              dispatch(
                                setDateFilter({
                                  field: "endDate1",
                                  value: moment(newValue)
                                    .endOf("month")
                                    .format("YYYY-MM-DD"),
                                })
                              );
                            }
                          }
                          switch (compareOption) {
                            case "year":
                              dispatch(
                                setDateFilter({
                                  field: "startDate2",
                                  value: moment(newValue)
                                    .subtract(1, "year")
                                    .format("YYYY-MM-DD"),
                                })
                              );
                              dispatch(
                                setDateFilter({
                                  field: "endDate2",
                                  value: moment(dateFilter.endDate1)
                                    .subtract(1, "year")
                                    .format("YYYY-MM-DD"),
                                })
                              );
                              break;
                            case "month":
                              handleMom("startDate", newValue);
                              break;
                            case "same":
                              dispatch(
                                setDateFilter({
                                  field: "startDate2",
                                  value: moment(newValue).format("YYYY-MM-DD"),
                                })
                              );
                              break;
                            default:
                              break;
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} sx={{ width: "100%" }} />
                        )}
                      />

                      <DatePicker
                        views={["year", "month", "day"]}
                        disableFuture
                        value={dateFilter.endDate1}
                        minDate={moment(dateFilter.startDate1)}
                        label="End Date"
                        components={{
                          OpenPickerIcon: () => (
                            <CalendarMonthIcon ref={dataPickerEndRef1} />
                          ),
                        }}
                        onChange={(newValue) => {
                          dispatch(
                            setDateFilter({
                              field: "endDate1",
                              value: moment(newValue).format("YYYY-MM-DD"),
                            })
                          );
                          switch (compareOption) {
                            case "year":
                              dispatch(
                                setDateFilter({
                                  field: "endDate2",
                                  value: moment(newValue)
                                    .subtract(1, "year")
                                    .format("YYYY-MM-DD"),
                                })
                              );
                              break;
                            case "month":
                              handleMom("endDate", newValue);
                              break;
                            case "same":
                              dispatch(
                                setDateFilter({
                                  field: "endDate2",
                                  value: moment(newValue).format("YYYY-MM-DD"),
                                })
                              );
                              break;
                            default:
                              break;
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{ width: "100%", mt: "10px!important" }}
                          />
                        )}
                      />
                      <DataSourceSelection
                        index={0}
                        selectedSource={selectedSource[0]}
                      ></DataSourceSelection>
                    </div>
                  )}
                  {dateFilterMode === 2 && (
                    <div>
                      <FormGroup sx={{ m: 1 }}>
                        <ButtonGroup
                          orientation="vertical"
                          variant="contained"
                          aria-label="Basic button group"
                        >
                          <Button
                            sx={{
                              flex: 1,
                            }}
                            disabled={
                              moment(dateFilter.startDate1).year() !==
                              moment(dateFilter.endDate1).year()
                            }
                            variant={
                              compareOption === "year"
                                ? "contained"
                                : "outlined"
                            }
                            onClick={() => {
                              dispatch(
                                setCompareOption({
                                  value: "year",
                                })
                              );
                              dispatch(
                                setDateFilter({
                                  field: "startDate2",
                                  value: moment(dateFilter.startDate1).subtract(
                                    1,
                                    "year"
                                  ),
                                })
                              );
                              dispatch(
                                setDateFilter({
                                  field: "endDate2",
                                  value: moment(dateFilter.endDate1).subtract(
                                    1,
                                    "year"
                                  ),
                                })
                              );
                              dispatch(
                                setDateGrouping({ value: "selected_period" })
                              );
                            }}
                          >
                            YoY
                          </Button>
                          <Button
                            sx={{
                              flex: 1,
                            }}
                            disabled={
                              moment(dateFilter.startDate1).month() !==
                              moment(dateFilter.endDate1).month()
                            }
                            variant={
                              compareOption === "month"
                                ? "contained"
                                : "outlined"
                            }
                            onClick={() => {
                              dispatch(
                                setCompareOption({
                                  value: "month",
                                })
                              );
                              handleMom();
                              dispatch(
                                setDateGrouping({ value: "selected_period" })
                              );
                            }}
                          >
                            MoM
                          </Button>
                          <Button
                            sx={{
                              flex: 1,
                            }}
                            variant={
                              compareOption === "same"
                                ? "contained"
                                : "outlined"
                            }
                            onClick={() => {
                              dispatch(
                                setCompareOption({
                                  value: "same",
                                })
                              );
                              dispatch(
                                setDateFilter({
                                  field: "startDate2",
                                  value: moment(dateFilter.startDate1),
                                })
                              );
                              dispatch(
                                setDateFilter({
                                  field: "endDate2",
                                  value: moment(dateFilter.endDate1),
                                })
                              );
                              dispatch(
                                setDateGrouping({ value: "selected_period" })
                              );
                            }}
                          >
                            相同日子
                          </Button>
                          <Button
                            sx={{
                              flex: 1,
                            }}
                            variant={
                              compareOption === "custom"
                                ? "contained"
                                : "outlined"
                            }
                            onClick={() => {
                              dispatch(
                                setCompareOption({
                                  value: "custom",
                                })
                              );
                              dispatch(
                                setDateGrouping({ value: "selected_period" })
                              );
                            }}
                          >
                            自訂
                          </Button>
                        </ButtonGroup>
                      </FormGroup>
                      <DatePicker
                        disableFuture
                        disabled={compareOption !== "custom"}
                        views={["year", "month", "day"]}
                        value={dateFilter.startDate2}
                        components={{
                          OpenPickerIcon: () => (
                            <CalendarMonthIcon ref={dataPickerStartRef2} />
                          ),
                        }}
                        label="Start Date"
                        onClose={() => {
                          dataPickerEndRef2.current.parentElement.click();
                        }}
                        onChange={(newValue) => {
                          dispatch(
                            setDateFilter({
                              field: "startDate2",
                              value: newValue
                                ? moment(newValue).format("YYYY-MM-DD")
                                : null,
                            })
                          );
                          if (dateFilter.endDate2 === null) {
                            if (
                              moment(newValue).endOf("month").isAfter(moment())
                            ) {
                              dispatch(
                                setDateFilter({
                                  field: "endDate2",
                                  value: moment().format("YYYY-MM-DD"),
                                })
                              );
                            } else {
                              dispatch(
                                setDateFilter({
                                  field: "endDate2",
                                  value: moment(newValue)
                                    .endOf("month")
                                    .format("YYYY-MM-DD"),
                                })
                              );
                            }
                          }

                          dispatch(
                            setDateGrouping({ value: "selected_period" })
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{ width: "100%", mt: "10px!important" }}
                          />
                        )}
                      />
                      <DatePicker
                        views={["year", "month", "day"]}
                        disableFuture
                        disabled={compareOption !== "custom"}
                        value={dateFilter.endDate2}
                        minDate={moment(dateFilter.startDate2).subtract(
                          1,
                          "day"
                        )}
                        label="End Date"
                        components={{
                          OpenPickerIcon: () => (
                            <CalendarMonthIcon ref={dataPickerEndRef2} />
                          ),
                        }}
                        onChange={(newValue) => {
                          dispatch(
                            setDateFilter({
                              field: "endDate2",
                              value: newValue
                                ? moment(newValue).format("YYYY-MM-DD")
                                : null,
                            })
                          );
                          if (newValue === null) {
                            dispatch(
                              setDateFilter({
                                field: "startDate2",
                                value: null,
                              })
                            );
                          }
                          dispatch(
                            setDateGrouping({ value: "selected_period" })
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{ width: "100%", mt: "10px!important" }}
                          />
                        )}
                      />
                      <DataSourceSelection
                        index={1}
                        selectedSource={selectedSource[1]}
                      ></DataSourceSelection>
                    </div>
                  )}
                </div>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </FormControl>
  );
}
